<template>
  <div id="footer_lk_left">
    <div
      class="footer_lk_left_soc_block"

    >
      <a href="https://t.me/optionlab" target="_blank">
        <div class="row">
          <img :src="store.serverConf[store.currentServer].path+'/images/telegramSm.png'" />
        </div>
      </a>
    </div>
    <div class="footer_lk_left_soc_block">
      <a
      
        :href=youtubehref[store.langSelect.value]
        target="_blank"
      >
        <div class="row">
          <img :src="store.serverConf[store.currentServer].path+'/images/youtubeSm.png'" />
        </div>
      </a>
    </div>
  </div>
</template>
<script>
import {useMyStorage} from "@/store/global"
export default {
  setup() {
    const store=useMyStorage();
    const youtubehref =["https://www.youtube.com/channel/UCaT0EOA-ye8dGB5Z5WNn5bA?view_as=subscriber","https://www.youtube.com/channel/UC_GS7IXMUqfuA4lQQnqlGxA?view_as=subscriber"]
    return {
      store,
      youtubehref
    }
  }
};
</script>
<style>
#footer_lk_left {
  width: 50px;
}
.footer_lk_left_soc_block {
  /*height: 111px;*/
  padding-top: 20px;
  position: relative;
}
.footer_lk_left_soc_block img {
  width: 48px;
  height: 48px;
}
.footer_lk_left_soc_block_title {
  /* Telegram // */

  font-family: Proxima Nova Bold;
  font-style: normal;
  /*font-weight: bold;*/
  font-size: 16px;
  line-height: 19px;
  text-transform: uppercase;

  color: #222222;
  margin-bottom: 15px;
}
.footer_lk_left_soc_block_text {
  font-family: Proxima Nova;
  font-style: normal;
  /*font-weight: normal;*/
  font-size: 15px;
  line-height: 18px;
  margin-left: 15px;

  color: #222222;
}
.footer_lk_left_soc_block a{
  text-decoration: none;
}
</style>